import { render, staticRenderFns } from "./ShopSearch.vue?vue&type=template&id=fa3b40ce"
import script from "./ShopSearch.vue?vue&type=script&lang=js"
export * from "./ShopSearch.vue?vue&type=script&lang=js"
import style0 from "./ShopSearch.vue?vue&type=style&index=0&id=fa3b40ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports